import { Component } from '@angular/core';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { ModalService } from '../../../services/modal/modal.service';
import { BaseModalComponent } from '../base-modal.component';
import { ModalType } from '../../../../js/interfaces/CoverpathTypes';
import { ToastService } from '../../overlays/toaster/toast-service.service';

@Component({
  selector: 'decline-tlic-confirmation',
  moduleId: module.id,
  templateUrl: './decline-tlic-confirmation.component.html',
})
export class DeclineTLICConfirmationComponent extends BaseModalComponent {
  constructor(
    protected modalService: ModalService,
    private accountCenterService: AccountCenterService,
    private toastService: ToastService
  ) {
    super(modalService);
  }

  //this function is called by the cancel button...
  cancel() {
    this.modalService.deactivate();
    this.postDeactivate(this.modalService);
  }

  //...and this one by the X in the upper right hand corner
  postDeactivate(modalService: ModalService) {
    modalService.activate({
      type: ModalType.paymentIfMissing,
      modalData: { instance: 'confirm-tlic' },
    });
  }

  async confirm() {
    await this.accountCenterService.declineTlicOffer();
    await this.accountCenterService.forceWorkflowStateNotification();

    this.modalService.deactivate();
    this.toastService.showToast('You declined temporary coverage.');
  }
}
